export default "__VITE_ASSET__BZfdpsIX__"